import LogoutIconHeader from 'assets/Icons/LogoutIconHeader';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { useAuth } from '@/hooks/useAuth';

interface Props {
  setShowDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
}

const LogoutButton: React.FC<Props> = ({ setShowDropDown, className }) => {
  const { onLogOut } = useAuth();

  return (
    <div className={twMerge(`px-5 pb-5`, className)}>
      <button
        onClick={() => {
          onLogOut();
          setShowDropDown(false);
        }}
        className='justify-center gap-x-1 w-full border border-dividerColor bg-grayZl-900 rounded-[8px]  py-2.5 px-4 text-textGrayColor hover:text-primary flex items-center'
      >
        <div className='flex justify-center items-center w-full'>
          <span className='flex gap-x-1 items-center text-[#9F9EA6]'>
            <div className='w-5 h-5'>
              <LogoutIconHeader />
            </div>
            <span className='text-xs/5 font-medium text-white'>Logout</span>
          </span>
        </div>
      </button>
    </div>
  );
};

export default LogoutButton;
